import { ChangeDetectorRef, Component, ElementRef, Injectable, OnInit, ViewChild } from '@angular/core';
import { UploadService } from '../../../../../../../common/services/Upload.service';
import { Subject } from 'rxjs';
import { IvrConst, IvrTab } from '../ivr.const';
import { IvrgatewayService } from '../../../../../../../common/services/Ivrgateway.service';
import { TableAction } from '../../../../../../../components/table-component/table.const';
import { ToastrService } from 'ngx-toastr';
import { BsModalService } from 'ngx-bootstrap';
import * as _ from 'lodash';
import { environment } from '../../../../../../../../environments/environment';
import { BaseListComponent } from '../../../../../../../components/base-list.component';

@Component({
  selector: 'switchboard-ivr-audio',
  templateUrl: './audio.component.html',
  styleUrls: ['../ivr.component.css', '../../switchboard.component.css'],
  providers: [BsModalService, UploadService, IvrgatewayService],
})
@Injectable()
export class AudioComponent extends BaseListComponent {
  @ViewChild('audioFile') audioFile: ElementRef;
  @ViewChild('audioTemplate') audioTemplate: ElementRef;

  public totalRow = 0;
  public change_message: any = [];
  public list: any = [];
  public is_load_data: any = false;

  public id_delete: number;

  public upload_dir;
  public id_file_delete = [];
  public audio_path = '';

  constructor(
    protected changeDetector: ChangeDetectorRef,
    protected toastr: ToastrService,
    protected modalService: BsModalService,
    private uploadService: UploadService,
    private ivrgatewayService: IvrgatewayService
  ) {
    super(changeDetector, toastr, modalService);
    this.upload_dir = environment.api_upload_evs;
    this.displayColumns = IvrConst.displayAudioColumns();
  }

  async ngOnInit() {
    await this.loadData();
  }

  async loadData(request: any = {}, sort: any = {}) {
    const payload = await this.buildBasePayload(request, sort);
    this.ivrgatewayService.listAudios(payload).subscribe(res => {
      if (!res.error && res.status == 200) {
        this.list = res.data.list;
        this.list.map(res => {
          res.file_name = IvrConst.displayFileNameColumns(res);
          res.display_description = IvrConst.displayAudioDescriptionColumns(res);
          return res;
        });
        this.initPage(res.data.total);
      }
    });
  }

  async addFile() {
    if (!this.model.FILE) {
      return this.toastr.error('File không được bỏ trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }

    if (this.model.FILE.size > 2000000) {
      return this.toastr.error('File ', 'Yêu cầu file .wav,  có dung lượng tối đa 2mb', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }

    if (this.model.FILE.type !== 'audio/wav') {
      return this.toastr.error('File ', 'File ghi âm không hợp lệ', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    if (this.model.name) {
      this.model.name = this.model.name.trim();
    } else {
      this.toastr.error('Tên không được bỏ trống', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
    this.ivrgatewayService
      .createAudio(
        {
          name: this.model.name,
          description: this.model.description,
        },
        this.model.FILE
      )
      .then(
        async (res: any) => {
          if (!res.error && res.status == 200) {
            this.throwSuccess('Thêm mới thành công');
            this.modalRef.hide();
            await this.loadData();
          } else {
            this.message = {
              class: 'alert dark alert-danger',
              content: res.message,
            };
          }
        },
        error => {
          this.message = {
            class: 'alert dark alert-danger',
            content: error.message,
          };
        }
      );
  }

  async changeAudioFile($event) {
    const files = $event.srcElement.files;
    if (files[0]) {
      if (files[0].type.match(/audio/)) {
        this.model.FILE = files[0];
      } else {
        $event.srcElement.value = '';
        this.toastr.error('File không đúng định dạng', 'Cảnh báo', {
          timeOut: 4000,
          positionClass: 'toast-bottom-right',
        });
      }
    }
  }

  async openDetailFile(cp) {
    this.audio_path = cp.real_path ? cp.real_path : this.upload_dir + '/' + cp.path;

    const config = {
      backdrop: true,
      ignoreBackdropClick: false,
      keyboard: false,
      class: 'mt-100',
    };
    this.modalRef = this.modalService.show(this.audioFile, config);
  }

  async openConfirmAudioDelete(id, multiple = false) {
    if (multiple) {
      this.id_file_delete = this.lstChecked;
    } else {
      this.id_file_delete = [id];
    }

    const y = confirm('Bạn có muốn xóa không?');
    if (y) {
      await this.submitDeleteFile();
    }
  }

  async submitDeleteFile() {
    if (this.id_file_delete.length > 0) {
      this.ivrgatewayService.deleteAudios({ ids: this.id_file_delete }).subscribe(async res => {
        if (res) {
          const error = res.error;
          if (error) {
            this.toastr.error('Xóa không thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
          } else {
            this.toastr.success('Xóa thành công', '', {
              timeOut: 4000,
              positionClass: 'toast-bottom-right',
            });
            await this.loadData();
          }
        }
      });
    } else {
      this.toastr.error('Xóa không thành công', '', {
        timeOut: 4000,
        positionClass: 'toast-bottom-right',
      });
    }
  }

  async openModal(template: ElementRef, id?: any) {
    this.message = null;
    const config = {
      backdrop: true,
      ignoreBackdropClick: true,
      keyboard: false,
    };
    this.model = {};
    this.typeModal = id ? 'edit' : 'add';
    this.modalRef = this.modalService.show(template, config);
  }

  async handleAction(type: any, item?: any) {
    switch (type) {
      case TableAction.add:
        await this.openModal(this.audioTemplate);
        break;
      case TableAction.view:
        await this.openDetailFile(item);
        break;
      case TableAction.delete:
        await this.openConfirmAudioDelete(item.id);
        break;
      case TableAction.deleteAll:
        await this.openConfirmAudioDelete('', true);
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/setting/switchboard/ivr/audio/audio.component.ts